/* type these for later */

import type { PathRouteType } from "$/lib/types/Routes.types";

export const CLIENT_ROUTES = {
  MARKETING_MONITORING: "/market-monitoring",
  DASHBOARD: "/tableau-de-bord",
  CLIENT_PROFILE: "/client-profile",
} satisfies Record<string, PathRouteType>;

export const CONSULTANT_ROUTES = {
  ORGANIZATIONS: "/organizations",
  NEW_ORGANIZATION: "/organizations/new",
  ORGANIZATION: "/organizations/$id",
  CONSULTANTS: "/consultants",
  CONTRACTS: "/contracts",
  NEW_CONTRACT: "/contracts/new",
  CONTRACT: "/contracts/$id",
  NEW_LOT: "/lots/new",
  LOT: "/lots/$id",
  PROFILE: "/profile",
} satisfies Record<string, PathRouteType>;

export const ROUTES = {
  HOMEPAGE: "/",
  LOGIN: "/login",
  VERIFY: "/auth/verify",
  ...CONSULTANT_ROUTES,
  ...CLIENT_ROUTES,
} satisfies Record<string, PathRouteType>;
